import { workspacesPreRemove } from './workspacesCollectionHooks';

export default {
  workspacesPreRemove,
};
